/**
 * Coure.Hub.PartnerContentService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContentRetrivalTypeEnum } from './contentRetrivalTypeEnum';
import { ContentType } from './contentType';

export interface CreatePartnerContentRequestDto { 
    partnerId?: string;
    contentName?: string;
    retrievalType?: ContentRetrivalTypeEnum;
    category?: string;
    urlMethod?: string;
    systemRouteId?: string;
    contentType?: ContentType;
    file?: Blob;
}